import axios from "axios";
import accessToken from "./jwt-token-access/accessToken";
//pass new generated access token here
const token = accessToken;
//login token
// var loginToken = JSON.parse(localStorage.getItem("authUser"));
//apply base url for axios
const API_URL = process.env.REACT_APP_Domain;
//Histroy for Reset Data

// Session expiry handler
const clearSessionAndRedirect = () => {
  if (localStorage.getItem("authUser") !== null) {
    localStorage.removeItem("authUser");
    localStorage.removeItem("setpassword");
    localStorage.removeItem("prevRoute");
    localStorage.removeItem("jobId");
    window.location.href = "/login/organization";
  }
};

const parseErrorResponse = async (response) => {
  const errorBody = await response.json().catch(() => ({
    error: true,
    statusCode: response.status,
    message: "An unexpected error occurred.",
  }));
  throw errorBody;
};

const handleCatch = (err) => {
  if (err === null || err === undefined) {
    throw "An unexpected error occurred. Please try again.";
  }

  console.log("🐛 handleCatch received:", err);
  if (err.requiresAuth && err.authUrl) {
    console.log("✅ handleCatch passing OAuth to saga");
    throw err;
  }

  if (err instanceof SyntaxError) {
    return "";
  }
  let message = "Sorry! the page you are looking for could not be found";

  if (err.error && err.statusCode === 403) {
    window.location.href = "/pages-403";
    return;
  }
  if (err.error && err.statusCode === 423) {
    throw err;
  }

  if (
    (err.error && (err.timestamp || err.statusCode === 307)) ||
    (!err.success && err.message)
  ) {
    throw err.message;
  }

  if (err.response && err.response.status) {
    switch (err.response.status) {
      case 404:
        break;
      case 500:
        message =
          "Sorry! something went wrong, please contact our support team";
        break;
      case 401:
        clearSessionAndRedirect();
        message = "Invalid credentials";
        break;
      default:
        message = err[1];
        break;
    }
  }

  if (err.errorCode && err.error) {
    if (err.errorCode === 403) {
      window.location.href = "/pages-403";
      return;
    }
    if (err.error) {
      message = err.error;
    } else {
      message = "Sorry! something went wrong, please contact our support team";
    }
  }

  throw message;
};

const handleAuthetication = (res, url, requestType) => {
  if (res.logout) {
    window.location.href = "/logout";
  } else if (res.setTokens) {
    return checkForAccessToken(res, requestType, url, null);
  } else if (res.requiresAuth && res.authUrl) {
    return res;
  } else if ("error" in res) {
    throw res;
  }
  return res;
};

function checkForAccessToken(response, type, url, data) {
  try {
    var user = JSON.parse(localStorage.getItem("authUser"));
    user.accessToken = response.accessToken;
    user.refreshToken = response.refreshToken;
    localStorage.setItem("authUser", JSON.stringify(user));
    if (type === "GET") {
      return get(url);
    }
    return post(url, data);
  } catch (e) {}
}

function getHeaders(url) {
  let headers = {};
  if (!url.includes("bulkimportunzip")) {
    headers = {
      "Content-Type": "application/json",
    };
  }

  if (!url.includes("account/")) {
    try {
      var user = JSON.parse(localStorage.getItem("authUser"));
      headers.accesstoken = user.accessToken;
      headers.refreshtoken = user.refreshToken;

      headers.companyId = user.companyId;
      headers.userId = user.clientId;
    } catch (e) {
      console.error("Error setting headers:", e);
    }
  }
  return headers;
}

function getHeadersForFeedBack(url, code) {
  let headers = {};

  headers = {
    "Content-Type": "application/json",
    accessCode: code,
  };
  return headers;
}

const axiosApi = axios.create({
  baseURL: API_URL,
});

// Request
export async function externalGet(url) {
  return fetch("https://" + url)
    .then(async (response) => {
      if (response.status >= 200 || response.status <= 299)
        return response.json();
      await parseErrorResponse(response);
    })
    .then((res) => {
      return handleAuthetication(res, url, "GET");
    })
    .catch((err) => {
      handleCatch(err);
    });
}

const modifyPromise = async (data) => {
  const result = await data;
  return result;
};

const buildQueryString = (params) => {
  if (!params || typeof params !== "object") return "";

  const filteredParams = Object.entries(params)
    .filter(
      ([key, value]) =>
        value !== null &&
        value !== "null" &&
        value !== "" &&
        key !== "type" &&
        key !== "payload",
    )
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(value)}`,
    )
    .join("&");

  return filteredParams ? `?${filteredParams}` : "";
};

export async function get(url, params = null) {
  const queryString = url.includes("?") ? "" : buildQueryString(params);
  const fullUrl = url + queryString;

  const requestOptions = {
    method: "GET",
    headers: getHeaders(url),
  };

  return fetch(API_URL + fullUrl, requestOptions)
    .then(async (response) => {
      if (
        (response.status >= 200 || response.status <= 299) &&
        url === "email/test"
      ) {
        return modifyPromise(response.text());
      } else if (response.status >= 200 || response.status <= 299) {
        const text = await response.text();
        try {
          return text ? JSON.parse(text) : {};
        } catch (e) {
          return {};
        }
      }

      if (response.status === 404 && url.includes("/recruitment/shortlist")) {
        const error = new Error("Shortlist details not found.");
        error.isExpected404 = true;
        throw error;
      }

      await parseErrorResponse(response);
    })
    .then((res) => {
      return handleAuthetication(res, url, "GET");
    })
    .catch((err) => {
      if (err && err.isExpected404) {
        throw err.message;
      }
      handleCatch(err);
    });
}

export async function post(
  url,
  data,
  companyId,
  config = { "Content-Type": "application/json;charset=UTF-8" },
) {
  const headers = getHeaders(url);
  if (companyId !== undefined && companyId !== null) {
    headers.companyId = companyId;
  }

  const requestOptions = {
    method: "POST",
    headers: headers,
    body: JSON.stringify(data),
  };
  return fetch(API_URL + url, requestOptions)
    .then(async (response) => {
      if (response.status === 401) {
        const responseData = await response.json();
        if (responseData.requiresAuth && responseData.authUrl) {
          console.log("🚀 POST: OAuth detected!", responseData);
          throw responseData;
        }
        clearSessionAndRedirect();
        throw new Error("Invalid credentials");
      }
      if (response.status >= 200 && response.status <= 299)
        return response.json();
      await parseErrorResponse(response);
    })
    .then((res) => {
      return handleAuthetication(res, url, "POST");
    })
    .catch((err) => {
      handleCatch(err);
    });
}

export async function postFeedback(
  url,
  data,
  code,
  config = {
    "Content-Type": "application/json;charset=UTF-8",
  },
) {
  const requestOptions = {
    method: "POST",
    headers: getHeadersForFeedBack(url, code),
    body: JSON.stringify(data),
  };
  return fetch(API_URL + url, requestOptions)
    .then(async (response) => {
      if (response.status >= 200 || response.status <= 299)
        return response.json();
      await parseErrorResponse(response);
    })
    .then((res) => {
      return handleAuthetication(res, url, "POST");
    })
    .catch((err) => {
      if (err && err.requiresAuth && err.authUrl) {
        throw err;
      }
      handleCatch(err);
    });
}

export async function postMultiPart(url, data) {
  const requestOptions = {
    method: "POST",
    headers: getHeaders(url),
    body: data,
  };

  return await fetch(API_URL + url, requestOptions)
    .then(async (response) => {
      if (response.status >= 200 || response.status <= 299)
        return response.json();
      await parseErrorResponse(response);
    })
    .then((res) => {
      if (res.logout) {
        window.location.href = "/logout";
      } else if (res.setTokens) {
        return checkForAccessToken(res, "POST", url, data);
      } else if ("error" in res) {
        let message = res;
        throw message;
      }
      return res;
    })
    .catch((err) => {
      let message = err.message
        ? err.message
        : "Sorry! the page you are looking for could not be found";
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! the page you are looking for could not be found";
            break;
          case 500:
            message =
              "Sorry! something went wrong, please contact our support team";
            break;
          case 401:
            clearSessionAndRedirect();
            message = "Invalid credentials";
            break;
          default:
            message = err[1];
            break;
        }
      }
      if (err.errorCode && err.error) {
        if (err.error) {
          message = err.error;
        } else {
          message =
            "Sorry! something went wrong, please contact our support team";
        }
      }
      throw message;
    });
}

export async function patch(
  url,
  data,
  config = {
    "Content-Type": "application/json;charset=UTF-8",
  },
) {
  const requestOptions = {
    method: "PATCH",
    headers: getHeaders(url),
    body: JSON.stringify(data),
  };
  return fetch(API_URL + url, requestOptions)
    .then(async (response) => {
      if (response.status >= 200 || response.status <= 299)
        return response.json();
      await parseErrorResponse(response);
    })
    .then((res) => {
      return handleAuthetication(res, url, "PATCH");
    })
    .catch((err) => {
      handleCatch(err);
    });
}

export async function put(url, data, config = {}) {
  return axiosApi
    .put(url, { ...data }, { ...config })
    .then((response) => response.data);
}

export async function put2(
  url,
  data,
  config = {
    "Content-Type": "application/json;charset=UTF-8",
  },
) {
  const requestOptions = {
    method: "PUT",
    headers: getHeaders(url),
    body: JSON.stringify(data),
  };
  return fetch(API_URL + url, requestOptions)
    .then(async (response) => {
      if (response.status >= 200 || response.status <= 299)
        return response.json();
      await parseErrorResponse(response);
    })
    .then((res) => {
      return handleAuthetication(res, url, "PUT");
    })
    .catch((err) => {
      handleCatch(err);
    });
}

export async function del1(url, config = getHeaders(url)) {
  return await axiosApi
    .delete(url, { ...config })
    .then((response) => response.data);
}

export async function del(url) {
  const requestOptions = {
    method: "DELETE",
    headers: getHeaders(url),
  };
  return fetch(API_URL + url, requestOptions)
    .then(async (response) => {
      if (response.status >= 200 || response.status <= 299)
        return response.json();
      await parseErrorResponse(response);
    })
    .then((res) => {
      if (res.logout) {
        window.location.href = "/logout";
      } else if (res.setTokens) {
        return checkForAccessToken(res, "GET", url, null);
      } else if ("error" in res) {
        throw res;
      }
      return res;
    })
    .catch((err) => {
      let message = "Sorry! the page you are looking for could not be found";
      if (err && err.error && err.timestamp) {
        throw err.message;
      }

      if (err && err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! the page you are looking for could not be found";
            break;
          case 500:
            message =
              "Sorry! something went wrong, please contact our support team";
            break;
          case 401:
            clearSessionAndRedirect();
            message = "Invalid credentials";
            break;
          default:
            message = err[1];
            break;
        }
      }
      if (err && err.errorCode && err.error) {
        if (err.errorCode === 403) {
          window.location.href = "/pages-403";
          return;
        }
        if (err.error) {
          message = err.error;
        } else {
          message =
            "Sorry! something went wrong, please contact our support team";
        }
      }
      throw message;
    });
}

// creating delete function for checking the status code
export async function del2(url) {
  const requestOptions = {
    method: "DELETE",
    headers: getHeaders(url),
  };
  return fetch(API_URL + url, requestOptions)
    .then(async (response) => {
      if (response.status >= 200 || response.status <= 299)
        return response.json();
      await parseErrorResponse(response);
    })
    .then((res) => {
      return handleAuthetication(res, url, "DELETE");
    })
    .catch((err) => {
      handleCatch(err);
    });
}

export async function del3(url) {
  const requestOptions = {
    method: "DELETE",
    headers: getHeaders(url),
  };
  return fetch(API_URL + url, requestOptions)
    .then(async (response) => {
      if (
        (response.status >= 200 || response.status <= 299) &&
        url === "email/test"
      ) {
        return modifyPromise(response.text());
      } else if (response.status >= 200 || response.status <= 299) {
        return response !== null && response !== "" ? response.json() : "";
      }
      await parseErrorResponse(response);
    })
    .then((res) => {
      return handleAuthetication(res, url, "GET");
    })
    .catch((err) => {
      handleCatch(err);
    });
}

export async function getBlob(url, params = null) {
  const queryString = url.includes("?") ? "" : buildQueryString(params);
  const fullUrl = url + queryString;

  const requestOptions = {
    method: "GET",
    headers: getHeaders(url),
  };

  return fetch(API_URL + fullUrl, requestOptions)
    .then(async (response) => {
      if (response.status >= 200 && response.status <= 299) {
        const blob = await response.blob();
        return {
          blob,
          contentType: response.headers.get("content-type"),
          contentDisposition: response.headers.get("content-disposition"),
        };
      }
      await parseErrorResponse(response);
    })
    .then((res) => {
      return handleAuthetication(res, url, "GET");
    })
    .catch((err) => {
      handleCatch(err);
    });
}
